<div id="container">
    <img src="../../../assets/sml_calendar.png" alt="dp" width="13.5px" height="15px" id="img">
    <div id="text">Deadline: {{deadlineString}}</div>
</div>
